import request from "@/utils/request";

export default class UserAPI {
  // 取得標準時間
  static getStandardTime() {
    return request.get("/time");
  }
  // 登入
  static login(access_code) {
    return request.post("/user/login", { access_code });
  }
  static logout() {
    return request.post("/user/logout");
  }
}
